import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import Title from "features/components/title";
import Text from "features/components/text";
import {__} from "services/i18n";
import {Tabber, TabberChild} from "features/components/tabber";
import ProfileEdit from "features/pages/profile/edit-profile";
import CompanyEdit from "features/pages/profile/edit-company";
import Button from "features/components/button";
import {profileData} from "store/reducer/user/profile/selectors";
import PublicProfileBox from "features/components/public-profile-box";
import PublicProfileSettings from "features/pages/profile/public-profile-settings";
import {useMediaQuery} from "services/utils/utils";
import {MOBILE_MEDIA_QUERY_THRESHOLD} from "constants.js";
import ProfileRecommendations from "features/pages/profile/recommendation";
/* istanbul ignore next */
const mapStateToProps = state => ({
    profile: profileData(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {

};

export const ProfilePage = (props) => {
    const {profile} = props;
    const goToPublicProfile = useCallback(() => {
        window.open(`/#/p/${profile.slug}`, "_blank");
    }, [profile]);

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);

    const renderTitle = useCallback(() => {
        return <>
            <Title size={34}>{__("profile-page.title")}</Title>
            <Text size={16}>{__("profile-page.text")}</Text>
        </>;
    }, []);

    return <LoggedInLayout className="profile-page" type={"light"}>
        <div className="sidebar-wrapper">
            <div className="content">
                {!isMobile && renderTitle()}
                <Tabber disableTab={false}>
                    <TabberChild title={__("profile-page.tabber.profile")}>
                        <ProfileEdit />
                    </TabberChild>
                    <TabberChild title={__("profile-page.tabber.company")}>
                        <CompanyEdit />
                    </TabberChild>
                    <TabberChild title={__("profile-page.tabber.recommendations")}>
                        <ProfileRecommendations />
                    </TabberChild>
                </Tabber>
            </div>
            <div className="sidebar">
                {isMobile && renderTitle()}
                <Button title={__("profile-page.show-as-visitor")} onClick={goToPublicProfile} icon={"eye"} type={"accent"} />
                <PublicProfileBox />
                <PublicProfileSettings />
            </div>
        </div>
    </LoggedInLayout>
};
ProfilePage.propTypes = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);